// extracted by mini-css-extract-plugin
export default {"member_name_link":"styles_member_name_link__CNYvc","owner_name_link":"styles_owner_name_link__Of0op","names_container":"styles_names_container__dRgqC"};